import * as _ from 'lodash';
import { ImCourseDiff } from 'Src/ng2/shared/services/im-models/im-course-diff';
import { ImGapPlan } from 'Src/ng2/shared/services/im-models/im-gap-plan';
import { ImSchool } from 'Src/ng2/shared/services/im-models/im-school';
import { CreditRequirements } from '../../../../../../ng2/shared/constants/credit-requirements.constant';

angular.module('nv.singleStudent').controller('StudentCreditGapsPanelBoxesCtrl', studentCreditGapsPanelBoxesCtrl);

function studentCreditGapsPanelBoxesCtrl(
  $scope,
  ImSchool: ImSchool,
  ImStudentCreditGaps,
  CourseDiff,
  GapPlan,
  ImGapPlan: ImGapPlan,
  ImCourseDiff: ImCourseDiff,
) {
  // tslint:disable-next-line:class-name
  class _CreditGapBox {
    order;
    gradReq;
    human;
    humanShort;
    setSharedState;
    netGaps;
    _netGaps;
    pendingAddsForGradReq;
    pendingDropsForGradReq;
    _startGap;
    pendingAndFutureGapPlansForGradReq;
    cssClass;

    // tslint:disable-next-line:max-line-length
    constructor(
      student,
      pendingCurrentTermCourseDiffs,
      pendingAndFutureGapPlans,
      studentNetGaps,
      gradReq,
      school,
      order,
      currentTermYear,
      setSharedState,
    ) {
      const creditReq = _.find(CreditRequirements, { camelCase: gradReq });

      this.order = order;
      this.gradReq = gradReq;
      this.human = creditReq.human;
      this.humanShort = creditReq.humanShort;
      this.setSharedState = setSharedState;

      /**
       * netGaps - used for displaying text value
       * `4` gaps will be displayed in DOM as `-4`
       */

      this.netGaps = studentNetGaps;

      /**
       * _netGaps - used for box coloring
       * The raw value received by constructor will be used to calc colors
       */
      this._netGaps = studentNetGaps;
      // tslint:disable-next-line:max-line-length
      const filteredCourseDiffsForGradReq = ImCourseDiff.getAddDropsForGradReq(
        pendingCurrentTermCourseDiffs,
        gradReq,
        school,
      );
      this.pendingAddsForGradReq = filteredCourseDiffsForGradReq.add.length;
      this.pendingDropsForGradReq = filteredCourseDiffsForGradReq.drop.length;
      // tslint:disable-next-line:max-line-length
      this.pendingAndFutureGapPlansForGradReq = ImGapPlan.filterForGradReq(
        pendingAndFutureGapPlans,
        gradReq,
        currentTermYear,
      ).length;
      this._startGap = ImStudentCreditGaps.getStartGapForGradReq(student, gradReq);
      this.cssClass = this.getCssClass();
    }

    getCssClass() {
      const creditGapStatus = {
        startGap: this._startGap,
        netGaps: this._netGaps,
      };

      if (creditGapStatus.startGap < 0) {
        if (creditGapStatus.netGaps > 0) return 'light-purple';
        if (creditGapStatus.netGaps === 0) return 'light-green';
        if (creditGapStatus.netGaps < 0) return 'light-red';
      }

      if (creditGapStatus.startGap === 0) {
        if (creditGapStatus.netGaps > 0) return 'light-purple';
        if (creditGapStatus.netGaps === 0) return 'green';
        if (creditGapStatus.netGaps < 0) return 'light-red';
      }

      if (creditGapStatus.startGap > 0) {
        if (creditGapStatus.netGaps > 0) return 'light-purple';
        if (creditGapStatus.netGaps === 0) return 'light-green';
        if (creditGapStatus.netGaps < 0) return 'light-red';
      }

      return 'default';
    }

    selectCreditReq(gradReq) {
      const propName = 'selectedCreditReq';
      const value = _.find(CreditRequirements, { camelCase: gradReq });

      this.setSharedState({ propName, value });
    }
  }

  this._setCreditGapBoxes = function() {
    const currentTermYear = ImSchool.getCurrentTermYear(this.school);
    const pendingCurrentTermCourseDiffs = ImCourseDiff.filterForPendingCurrentTerm(this.studentDiffs, currentTermYear);
    const pendingAndFutureGapPlans = ImGapPlan.filterForPendingAndFuture(this.studentGapPlans, currentTermYear);

    let includedReqs = _.filter(CreditRequirements, (creditReq: any) => {
      if (creditReq.orders.creditGapPanel < 14 && creditReq.orders.creditGapPanel !== null) {
        return creditReq;
      }
    });

    this.creditGapBoxes = _.sortBy(
      _.map(includedReqs, (creditReq: any) => {
        let gradReq = creditReq.camelCase;
        // tslint:disable-next-line:max-line-length
        let netGaps = ImStudentCreditGaps.getNetGapsForGradReq(
          this.student,
          pendingCurrentTermCourseDiffs,
          pendingAndFutureGapPlans,
          this.school,
          gradReq,
        );
        // tslint:disable-next-line:max-line-length
        return new _CreditGapBox(
          this.student,
          pendingCurrentTermCourseDiffs,
          pendingAndFutureGapPlans,
          netGaps,
          gradReq,
          this.school,
          creditReq.orders.creditGapPanel,
          currentTermYear,
          this.setSharedState,
        );
      }),
      req => {
        if (req) {
          return req.order;
        }
      },
    );

    let eligibleForCreditRecovery = this.student.creditDetails.creditRecovery.eligibleCoursesString;
    if (eligibleForCreditRecovery) {
      this.eligibleForCreditRecovery = '*Potentially eligible for credit recovery: ' + eligibleForCreditRecovery;
    }
  };

  $scope.$watch(
    () => {
      return this.studentDiffs;
    },
    () => {
      this._setCreditGapBoxes();
    },
    true,
  );

  $scope.$watch(
    () => {
      return this.studentGapPlans;
    },
    () => {
      return this._setCreditGapBoxes();
    },
    true,
  );
}
